exports.__esModule = true;
var __importDefault = function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var docs_config_1 = __importDefault(require("@tencent/docs-config"));
var appConfigInstance = docs_config_1.default.getInstance();
var npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
exports.default = (function () {
    var p = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.CDN_ORIGIN) || "https://docs.gtimg.com/docs-design-resources";
    p = p + "/document-management/miniprogram/share-placeholder/"
    return {
        "application-pdf": p+"application-pdf@3x.png",
        "application-vnd.ms-excel": p+"application-vnd.ms-excel@3x.png",
        "application-vnd.ms-powerpoint": p+"application-vnd.ms-powerpoint@3x.png",
        "application-vnd.ms-word": p+"application-vnd.ms-word@3x.png",
        "application-vnd.tdocs-apps-addon": p+"application-vnd.tdocs-apps-addon@3x.png",
        "application-vnd.tdocs-apps.board": p+"application-vnd.tdocs-apps.board@3x.png",
        "application-vnd.tdocs-apps.default": p+"application-vnd.tdocs-apps.default@3x.png",
        "application-vnd.tdocs-apps.doc": p+"application-vnd.tdocs-apps.doc@3x.png",
        "application-vnd.tdocs-apps.flowchart": p+"application-vnd.tdocs-apps.flowchart@3x.png",
        "application-vnd.tdocs-apps.form": p+"application-vnd.tdocs-apps.form@3x.png",
        "application-vnd.tdocs-apps.markdown": p+"application-vnd.tdocs-apps.markdown@3x.png",
        "application-vnd.tdocs-apps.mind": p+"application-vnd.tdocs-apps.mind@3x.png",
        "application-vnd.tdocs-apps.rec": p+"application-vnd.tdocs-apps.rec@3x.png",
        "application-vnd.tdocs-apps.sheet": p+"application-vnd.tdocs-apps.sheet@3x.png",
        "application-vnd.tdocs-apps.slide": p+"application-vnd.tdocs-apps.slide@3x.png",
        "application-vnd.tdocs-apps.smartcanvas": p+"application-vnd.tdocs-apps.smartcanvas@3x.png",
        "application-vnd.tdocs-apps.smartsheet": p+"application-vnd.tdocs-apps.smartsheet@3x.png",
        "application_tencentlibrarydoc": p+"application_tencentlibrarydoc@3x.png",
        "application_tencentlibrarypdf": p+"application_tencentlibrarypdf@3x.png",
        "application_tencentlibraryppt": p+"application_tencentlibraryppt@3x.png",
        "application_tencentlibrarysheet": p+"application_tencentlibrarysheet@3x.png",
        "audio": p+"audio@3x.png",
        "b_application-addon": p+"b_application-addon@3x.png",
        "b_application-audio": p+"b_application-audio@3x.png",
        "b_application-board": p+"b_application-board@3x.png",
        "b_application-default": p+"b_application-default@3x.png",
        "b_application-doc": p+"b_application-doc@3x.png",
        "b_application-flowchart": p+"b_application-flowchart@3x.png",
        "b_application-form": p+"b_application-form@3x.png",
        "b_application-image": p+"b_application-image@3x.png",
        "b_application-lide": p+"b_application-lide@3x.png",
        "b_application-mind": p+"b_application-mind@3x.png",
        "b_application-pdf": p+"b_application-pdf@3x.png",
        "b_application-rec": p+"b_application-rec@3x.png",
        "b_application-sheet": p+"b_application-sheet@3x.png",
        "b_application-slide": p+"b_application-slide@3x.png",
        "b_application-smartcanvas": p+"b_application-smartcanvas@3x.png",
        "b_application-smartsheet": p+"b_application-smartsheet@3x.png",
        "b_application-video": p+"b_application-video@3x.png",
        "image": p+"image@3x.png",
        "video": p+"video@3x.png",
    };
})();